import React from 'react'
import CartContentContext from 'services/cart/contexts/CartContentContext'

export default function useCartContent () {
  const cartContent = React.useContext(CartContentContext)

  if (cartContent === null) {
    throw new Error('Tried to use cart content, but got NULL (default value). Has it been provided?')
  }

  return cartContent
}
